import { Directive, Input, OnInit, inject } from '@angular/core';
import { getDataSourceFilteredAndSortedData } from '../helpers/dx-utils';
import { Column, ExportingEvent } from 'devextreme/ui/data_grid_types';
import { utils, writeFileXLSX } from 'xlsx';
import { Title } from '@angular/platform-browser';
import { getDateTimeWithUnderscores } from '../helpers/date.utils';

@Directive({
	selector: '[appDxTableController]',
	exportAs: 'appDxTableController',
	standalone: true
})
export class DxTableControllerDirective implements OnInit {

	@Input()
	public  tableHeights: (number |  string | undefined)[] = [400, 700, 1000];

	private _tableHeightIndex: number = 0;
	private _tableHeightIncrement: number = 1;

	@Input()
	public tableHeight: number | string | undefined;

	@Input()
	public minTableHeight: number | Function | string | undefined = 400;

	public switchTableHeight(): void {
		// Update the table height first.
		this.tableHeight = this.tableHeights[this._tableHeightIndex];

		// Change the index based on the increment.
		this._tableHeightIndex += this._tableHeightIncrement;

		// Ensure the index loops around when it reaches the end or start of the array.
		if (this._tableHeightIndex >= this.tableHeights.length) {
			this._tableHeightIndex = 0;
		} else if (this._tableHeightIndex < 0) {
			this._tableHeightIndex = this.tableHeights.length - 1;
		}
	}

	public _titleService: Title = inject(Title);

	private _prepareDataForExport(evt: ExportingEvent, data: any): any {
		const visibleDataColumns: Column<any, any>[] = evt.component.getVisibleColumns().filter((column) => !column.type);
		const columnDataFieldToCaption: { [key: string]: string } = visibleDataColumns.reduce(
			(accumulator, column) => {
				const key = String(column.dataField);
				const value = String(column.caption);

				accumulator[key] = value;

				return accumulator;
			},
			{} as { [key: string]: string }
		);

		return data.map(
			(item) => {
				const newItem: { [key: string]: any } = {};

				for (const key in columnDataFieldToCaption) {
					newItem[columnDataFieldToCaption[key]] = item[key];
				}

				return newItem;
			}
		);
	}

	public onExporting(evt: ExportingEvent, name: string = this._titleService.getTitle()): void {
		getDataSourceFilteredAndSortedData(
			evt.component,
			(data) => {
				data = this._prepareDataForExport(evt, data);

				const ws = utils.json_to_sheet(data);
				const wb = utils.book_new();

				utils.book_append_sheet(wb, ws, "Data");

				writeFileXLSX(wb, `${name}_${getDateTimeWithUnderscores()}.xlsx`);
			},
			evt.selectedRowsOnly
		);
	}

	constructor() { }

	ngOnInit(): void {
		if (this.tableHeights.includes(this.tableHeight)) {
			this._tableHeightIndex = this.tableHeights.findIndex((item) => item === this.tableHeight);

			this.switchTableHeight();
		} else {
			this.tableHeights.push(this.tableHeight);
		}
	}
}
